export default "__VITE_ASSET__BDY$5Wn8__"